import type { Machine } from '@/types/models';

type Rag = 'green' | 'amber' | 'red' | 'grey';

/** Hours until the next service, and the warning colour for it. The same
 *  rule as v_service_status on the server - amber inside the configured
 *  window, red once overdue. */
export function serviceState(m: Machine, amberHours: number, amberKm = 1000) {
  const next = m.next_service_hours ??
    (m.last_service_hours != null && m.service_interval_hours != null
      ? m.last_service_hours + m.service_interval_hours
      : null);
  if (next == null) return { remaining: null as number | null, rag: 'grey' as Rag, next: null };
  const remaining = Math.round((next - m.current_hour_meter) * 10) / 10;
  const window = m.hour_meter_unit === 'km' ? amberKm : amberHours;
  const rag: Rag = remaining < 0 ? 'red' : remaining < window ? 'amber' : 'green';
  return { remaining, rag, next };
}
